import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { initFbPixel } from "@/lib/fbPixel";

initFbPixel();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register PWA service worker so Metazik is installable as a real app on Android
// (Chrome) and iOS (Add to Home Screen). It also enables offline shell.
//
// IMPORTANT — cache-bust: we append a version query string so a returning user
// whose browser has cached the old sw.js still refetches the new one. We also
// force `registration.update()` on load and hard-reload once when a new worker
// takes control. This unblocks users stuck on a pre-iter19 bundle without any
// manual "clear cache" step.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js?v=2");
      // Actively ask the browser to check for an updated worker on every load — only once a
      // worker is active (asking while the first one is still installing is refused), and
      // the refusal is caught: update() answers with a promise, a try/catch never saw it.
      if (reg.active) reg.update().catch(() => { /* best-effort */ });
      // Force-activate a waiting worker as soon as one installs.
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            nw.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
      // When a new worker takes control, hard-reload once so the fresh JS
      // bundle is served (guarded to avoid an infinite refresh loop).
      let reloaded = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });
    } catch { /* SW registration is best-effort */ }
  });
}
